import type { ReactNode } from "react";

/** Title and optional description above the toolbar. */
export function DataTableTitle({ title, description }: { title: ReactNode; description: ReactNode }): React.JSX.Element {
  return (
    <div className="nb-dt-head">
      <div>
        <h3 className="nb-dt-title">{title}</h3>
        {description ? <p className="nb-dt-desc">{description}</p> : null}
      </div>
    </div>
  );
}
